import { useState } from "react";
import { Trans } from "@lingui/macro";
import "./SocialsDropdown.css";
import ExternalLink from "components/ExternalLink/ExternalLink";
import dots from "img/Dots.svg";
import docsIcon from "img/Docs_icon.svg";
import blogIcon from "img/Blog_icon.svg";
import academyIcon from "img/Academy_icon.svg";
import twitterIcon from "img/Twitter_icon.svg";
import discordIcon from "img/Discord_icon.svg";
import telegramIcon from "img/Telegram_icon.svg";

function SocialsDropdown() {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="socials-dropdown" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div>
        <button className="App-cta small transparent socials-btn transition-effect">
          <img src={dots} alt="" />
        </button>
      </div>
      {isHovered && (
        <div className="socials-menu-items">
          <div className="menu-item-header">
            <p>
              <Trans>Explore Community</Trans>
            </p>
          </div>

          <ExternalLink href="https://docs.palmswap.org/" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Docs</Trans>
              </p>

              <img src={docsIcon} alt="Copy user address" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://blog.palmswap.org/" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Blog</Trans>
              </p>
              <img src={blogIcon} alt="Open address in explorer" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://academy.palmswap.org/" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Academy</Trans>
              </p>
              <img src={academyIcon} alt="Disconnect the wallet" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://academy.palmswap.org/" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Twitter</Trans>
              </p>
              <img src={twitterIcon} alt="Disconnect the wallet" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://discord.com/invite/B2EyhkQSZR" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Discord</Trans>
              </p>
              <img src={discordIcon} alt="Disconnect the wallet" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://t.me/PalmswapAnn" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Telegram Ann</Trans>
              </p>
              <img src={telegramIcon} alt="Disconnect the wallet" />
            </div>
          </ExternalLink>
          <ExternalLink href="https://t.me/Palmswapchat" className="socials-link">
            <div className="socials-menu-item">
              <p>
                <Trans>Telegram</Trans>
              </p>
              <img src={telegramIcon} alt="Disconnect the wallet" />
            </div>
          </ExternalLink>
        </div>
      )}
    </div>
  );
}

export default SocialsDropdown;
